import {GridFilterModel, GridSortModel} from '@mui/x-data-grid';
import {getFormatedDateForFilter} from '../../common/aur-data-grid-pro/useServerSideDataGrid';
import {
  columnsConfiguration,
  dateOperatorMap,
  sortFilterColumnFieldMap,
} from './constant';
import { ONLY_DATE_SHOW_FORMAT } from '../../../constants/constants';

const getColumnFilterType = (field: string) => {
  const col = columnsConfiguration.find((c) => c.field === field);
  return col?.headerFilter; // 'search' | 'filter' | 'date'
};

export const transformFilterModel = (filterModel: GridFilterModel) => {
  if (!filterModel?.items?.length) return [];

  const result: any[] = [];

  const grouped: Record<string, any[]> = {};

  filterModel.items.forEach((item) => {
    if (!grouped[item.field]) {
      grouped[item.field] = [];
    }
    grouped[item.field].push(item);
  });

  Object.entries(grouped).forEach(([field, items]) => {
    const type = getColumnFilterType(field);
    const mappedColumn = sortFilterColumnFieldMap[field] || field;

    // DATE HANDLING
    if (type === 'date') {
      if (items.length === 2) {
        const start = items.find((i) => i.operator === 'onOrAfter');
        const end = items.find((i) => i.operator === 'onOrBefore');

        if (start && end) {
          result.push({
            column: mappedColumn,
            operatorType: 'between',
            value: `${getFormatedDateForFilter(start.value,ONLY_DATE_SHOW_FORMAT)}|${getFormatedDateForFilter(end.value,ONLY_DATE_SHOW_FORMAT)}`,
          });
          return;
        }
      }

      const item = items[0];

      result.push({
        column: mappedColumn,
        operatorType: dateOperatorMap[item.operator] || item.operator,
        value: getFormatedDateForFilter(item.value,ONLY_DATE_SHOW_FORMAT),
      });

      return;
    }

    // NON-DATE
    items.forEach((item) => {
      if (item.value === undefined || item.value === '') return;

      let operator = item.operator;
      let value: any = item.value;

      if (type === 'search') {
        operator = 'contains';
        value = [value];
      } else if (type === 'filter') {
        operator = 'equals';
        value = Array.isArray(value) ? value : [value];
      }

      result.push({
        column: mappedColumn,
        operatorType: operator,
        value,
      });
    });
  });

  return result;
};

export const transformSortModel = (model: GridSortModel) => {
  if (!model?.length) return null;
  const {field, sort} = model[0];
  return {
    column: sortFilterColumnFieldMap[field] || field,
    direction: sort,
  };
};
